export default {
  pageFilters: [
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null
      }
    }
  ],
  queries: {
    topPerformingMovies: { fields: ['country', 'daysInPast'] },
    homepageMoviesAnticipation: { fields: ['country'] },
    trendingActors: { fields: ['country', 'contentType'] },
    trendingMovies: { fields: ['country'] }
  }
};
